module.exports = __webpack_public_path__ + "media/images/pc/stores/suns/icon_title_hibiscus-3e219653d3748dea5f0f32715d40d288.svg";